var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_55728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58125 12.4187 -3.8147e-06 8 -3.8147e-06C3.58125 -3.8147e-06 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C8.04688 16 8.09375 16 8.14062 15.9969V9.77187H6.42188V7.76875H8.14062V6.29375C8.14062 4.58437 9.18438 3.65312 10.7094 3.65312C11.4406 3.65312 12.0688 3.70625 12.25 3.73125V5.51875H11.2C10.3719 5.51875 10.2094 5.9125 10.2094 6.49062V7.76562H12.1938L11.9344 9.76875H10.2094V15.6906C13.5531 14.7312 16 11.6531 16 8Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_55728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.efe7a95d46ab6e323129d6cc8f8763f0.svg";
export { ForwardRef as ReactComponent };